import { useEffect } from "react";

export const useOutsideAndEscapeClose = (ref, onClose) => {
  useEffect(() => {
    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClose();
      }
    };

    const handleEscapePress = event => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (ref.current) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEscapePress);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscapePress);
    };
  }, [ref, onClose]);
};
